/* eslint-disable camelcase */
// Replacement of the mixin for composition API
import { onMounted, onBeforeUnmount } from '#imports';
import type { TealiumData } from '@i22/td-longtail-vue-components';
import { useCartStore } from '~/stores/cart';
import { tealiumView, updateAutomaticLinkTracking } from '~/lib/tealium';
import serializeOffers from '~/lib/tealium/serializers/offer';

const DEFAULT_ORGANIZATION = 'ESH37';

export type TrackingOptions = {
  trackViewOnMount?: boolean;
  updateLinkTrackingOnMount?: boolean;
  delay?: number;
};

const getTealiumData = (tealiumData: TealiumData = {}) => {
  const shop_customer_type = 'nicht-bestandskunde';

  // @ts-ignore
  // eslint-disable-next-line no-undef,no-underscore-dangle
  const tealiumPageContentIdFromPath = $nuxt?._route?.path
    ?.split('/')
    ?.slice(1)
    ?.join('.')
    ?.replace('_', '');

  const page_content_id = `shop.telekom.de.privatkunden.${
    tealiumData.page_content_id || tealiumPageContentIdFromPath
  }`;

  const cartStore = useCartStore();

  const data: TealiumData = {
    page_type: 'theme',
    page_technical_id: '',
    login_status: 'not-logged-in',
    shop_customer_type,
    shop_mlid: '',
    shop_vb: '',
    shop_vo: DEFAULT_ORGANIZATION,
    shop_vpnr: '',
    shop_gutschein_kampagne: cartStore.couponCampaignName || '',
    shop_gutschein_vorhanden: cartStore.couponRedeemed ? 'ja' : 'nein',
    ...tealiumData,
    page_content_id,
  };
  // serialize offers
  if (data.items) {
    data.items = serializeOffers('view', data.items);
  }
  return data;
};

let startUpTimeout: null | number = null;

export const TrackAsync = (
  tealiumData: TealiumData = {},
  trackingOptions: TrackingOptions = {}
) => {
  if (startUpTimeout) {
    clearTimeout(startUpTimeout);
  }
  const options: TrackingOptions = {
    delay: process.env.APPLICATION_ENV === 'test' ? 0 : 100, // We have to wait for the meta data to be refreshed on csr.
    updateLinkTrackingOnMount: true,
    ...trackingOptions,
  };

  const doTrack = () => {
    tealiumView(getTealiumData(tealiumData));
    if (options.updateLinkTrackingOnMount) {
      updateAutomaticLinkTracking();
    }
  };

  if ((options.delay || 0) > 0) {
    // @ts-ignore
    startUpTimeout = setTimeout(doTrack, options.delay);
  } else {
    doTrack();
  }
};

export const Track = (tealiumData: TealiumData = {}, trackingOptions: TrackingOptions = {}) => {
  onMounted(() => {
    TrackAsync(tealiumData, trackingOptions);
  });

  onBeforeUnmount(() => {
    if (startUpTimeout) {
      clearTimeout(startUpTimeout);
    }
  });
};
